import { Alert, Paragraph, SectionHeading } from '@quickmd-llc/design-system';
import { Button } from '@quickmd-llc/design-system';

interface Props {
  handleClose: () => void;
}

export default function AccountBlockedAlert({
  handleClose,
}: Props): JSX.Element {
  return (
    <Alert open onClose={handleClose} size="sm">
      <SectionHeading className="mb-6">Booking Error</SectionHeading>

      <Paragraph size="sm" className="mb-6 text-left">
        If you are currently experiencing a medical emergency, please visit your
        nearest emergency medical facility or dial 911.
      </Paragraph>
      <Paragraph size="sm" className="mb-6 text-left">
        Your account is currently under review. Please refer to your most recent
        QuickMD Support Email for additional information. We understand that
        this may be frustrating, and we apologize for any inconvenience it may
        cause.
      </Paragraph>

      <div className="flex justify-end">
        <Button onClick={handleClose}>Okay</Button>
      </div>
    </Alert>
  );
}
